export class AsignacionPersistDto {
  asignacion : {
    idTipoAsignacion: number,
    idResponsableEmisor: number,
    idResponsableReceptor: number,
    observacion: string,
  };
	activos: any[];
}